import { Slot } from "radix-ui";

import { getSectionHeadingClass } from "./section-heading.styles";
import type { SectionHeadingProps } from "./section-heading.types";

export function SectionHeading({ className, size, ...props }: SectionHeadingProps) {
  return <Slot.Root className={getSectionHeadingClass({ className, size })} {...props} />;
}
